export enum RefundPolicy {
  in30Days = 'Refund in 30 days or less',
  exchange = 'Merchandise exchange only',
  noRefund = 'No Refund',
  other = 'Other',
}
